<template>
  <div class="rank-box">
    <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb-box">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>排行榜</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row class="zy-school">
      <el-tabs type="border-card" class="zy-list" @tab-click="changeTypeHandler">
        <el-tab-pane :label="card.name" v-for="(card,index) in menuList" :key="index">
          <div class="rank-infor">
            <h3>{{card.title}}</h3>
            <p>{{card.desc}}</p>
          </div>
          <div class="rank-content">
            <el-row class="collapse-box">
                <div>
                  <div v-if="schoolList.length == 0">
                    <ContentLoader  v-for="item in 12"  :key="item" primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="73" width="670" viewBox="0 0 670 73">
                      <rect x="85" y="13" width="117" height="13" />
                      <rect x="85" y="35" width="250" height="14" />
                      <rect x="590" y="25" width="80" height="18" />
                      <rect x="30" y="68" width="655" height="1" />
                      <circle cx="45" cy="35" r="20" />
                    </ContentLoader>
                  </div>
                  <div class="collapse-list" v-else v-for="(item,index) in schoolList" :key="index" @click="schoolDetailHandler(item.scl_id)">
                    <el-col :span="1" style="width:3.5%">
                      <img src="../../assets/images/rank-top1.png" alt="排名" v-if="item.scl_rank == 1" class="rank-top">
                      <img src="../../assets/images/rank-top2.png" alt="排名" v-else-if="item.scl_rank == 2" class="rank-top">
                      <img src="../../assets/images/rank-top3.png" alt="排名" v-else-if="item.scl_rank == 3" class="rank-top">
                      <div class="rank-number" v-else>{{item.scl_rank}}</div>
                    </el-col>
                      <el-col :span="2" style="width:7.5%">
                        <el-image :src="'https://gaokao.zmpajx.com/pic/' + item.scl_id + '.jpg'" alt="大学logo">
                            <div slot="error" class="image-slot">
                                <img src="../../assets/images/scl_default.png" alt="大学logo">
                            </div>
                        </el-image>
                      </el-col>
                      <el-col :span="17">
                      <div class="zytb-school-name">
                          {{item.scl_name}}<img src="../../assets/images/wz.png" alt="位置" v-if="item.scl_location">
                          <span v-if="item.scl_location">{{item.scl_location}}</span>
                      </div>
                      <div class="zytb-school-tag">
                          <!-- <template v-if="item.scl_nature_type == '6000'">
                              <span v-if="item.f211 == '1' || item.is_provincial == '1' || item.f985 == '1' || (item.dual_class != '38003' && item.dual_class)">
                                  本科
                              </span>
                              <span v-else>
                                  普通本科
                              </span>
                          </template>
                          <template v-if="item.scl_nature_type == '6001'">
                              <span v-if="item.is_doublehigh == '77'">
                                  专科
                              </span>
                              <span v-else>
                                  普通专科
                              </span>
                          </template> -->
                          <span>{{type_edu[item.scl_nature_type]}}</span>
                          <span v-if="item.scl_type == '5000'">综合</span>
                          <span v-if="item.scl_type == '5001'">理工</span>
                          <span v-if="item.scl_type == '5002'">农林</span>
                          <span v-if="item.scl_type == '5003'">医药</span>
                          <span v-if="item.scl_type == '5004'">师范</span>
                          <span v-if="item.scl_type == '5005'">语言</span>
                          <span v-if="item.scl_type == '5006'">财经</span>
                          <span v-if="item.scl_type == '5007'">政法</span>
                          <span v-if="item.scl_type == '5008'">体育</span>
                          <span v-if="item.scl_type == '5009'">艺术</span>
                          <span v-if="item.scl_type == '5010'">民族</span>
                          <span v-if="item.scl_type == '5011'">军事</span>
                          <span v-if="item.scl_type == '5012'">其他</span>
                          <span v-if="item.scl_nature == '36000'">公办</span>
                          <span v-if="item.scl_nature == '36001'">民办</span>
                          <span v-if="item.scl_nature == '36002'">中外合作办学</span>
                          <span v-if="item.f211 == '1'" style="background:#fff4e3;color:#fe9f0a;">211</span>
                          <span v-if="item.f985 == '1'" style="background:#fff0e9;color:$common-color;">985</span>
                          <span v-if="item.dual_class != '38003' && item.dual_class" style="background:#e4f4e9;color:#01c13b;">双一流</span>
                          <span v-if="item.is_provincial == '1'" style="background: #FDEFFF;color: #D250E0">省重点</span>
                          <span v-if="item.is_doublehigh == '77'" style="background: #ECEDFF;color: #5964FF">双高计划</span>
                      </div>
                      </el-col>
                      <el-col :span="4" v-if="activeIndex == '0' || activeIndex=='1'">
                        综合得分：<span>{{item.scl_rank_score}}</span>
                      </el-col>
                      <el-col :span="4" v-else>
                        世界排名：<span>{{item.scl_world_rank}}</span>
                      </el-col>
                      <div class="con-clear"></div>
                      <el-row class="con-line"></el-row>
                  </div>
                </div>
            </el-row>
            <el-pagination
                background
                layout="prev, pager, next, jumper"
                :total="totalData" :page-size="12" @current-change="schoolRankHandler" :current-page.sync="currentPage" v-if="totalData > 0 && schoolList.length > 0">
            </el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-row>
  </div>
</template>
 
<script>
import { getList } from '@/api/rank'
import { getSearchDic } from "@/api/zhiyuan"
import { ContentLoader } from 'vue-content-loader'
export default {
    components: {
        ContentLoader
    },
  data() {
    return {
      menuList: [
        {type: '1',name: '武书连',title:'武书连大学排行榜',desc:'武书连中国大学排名是中国管理科学研究院《中国大学评价》课题组（1991年成立，武书连任组长）发布的中国内地大学排行榜。排名从人才培养和科学研究两大指标计算所得，体现学校整体实力。'},
        {type: '2',name: '中国校友会',title:'中国校友会大学排行榜',desc:'艾瑞深中国校友会网大学排行榜以校友、质量、影响和贡献为主题特色连续19年发布校友会中国大学排名，备受中国高校和社会各界的广泛关注与高度认可，被人民日报、光明日报等国内外上百家国内外权威媒体广泛转载、报道和引用，已成为每年全国高考、考研考生与外国来华留学生填报志愿挑选大学及专业的权威参考指南。'},
        {type: '3',name: 'QS内地',title:'QS内地大学排行榜',desc:'QS世界大学综合排名是由英国一家国际教育市场咨询公司Quacquarelli Symonds（简称QS）所发表的年度世界大学排名，是参与机构最多、世界影响范围最广的排名之一，与泰晤士高等教育世界大学排名、U.S. News世界大学排名和软科世界大学学术排名被公认为四大较为权威的世界大学排名。'},
        {type: '4',name: 'USNews内地',title:'USNews内地大学排行榜',desc:'U.S.News世界大学排名是具有一定影响力的全球性大学排名，是公认的四大较为权威的世界大学排名，根据大学的学术水平、国际声誉等十项指标得出全球最佳大学排名，以便为全世界的学生在全球范围选择理想的大学提供科学的参考依据。'},
      ],
      activeIndex: 0,
      totalData: 0,
      schoolList: [],
      currentPage: 1,
      type_edu: {}
    }
  },
  created() {
    this.$store.commit('user/ADDCOUNT', 0);
    this.getSearchDicHandler();
    setTimeout(()=>{
      this.schoolRankHandler('1');
    }, 200)
  },
  methods: {
    getSearchDicHandler() {
      try {
        getSearchDic().then(res => {
          if (res.status != 200 || !res) {
            return
          }
          res.data.edu_type.map( item => {
            this.type_edu[item.dic_code] = item.dic_value
          })
        }).catch(error => {
          console.log(error);
        })
    } catch (error) { console.log(error) }
  },
    changeTypeHandler(e) {
      this.activeIndex = e.index;
      this.schoolList = [];
      this.currentPage = 1;
      this.totalData = 1;
      this.schoolRankHandler('1');
    },
    schoolRankHandler(page) {
      let rank_type = parseInt(this.activeIndex)+1;
      getList(rank_type,page).then(res => {
        this.totalData = res.data.count;
        res.data.data.map((item,index) => {
          item.scl_rank = (page-1) * 12 + index + 1;
          return item;
        })
        this.schoolList = [...res.data.data];
      })
    },
    schoolDetailHandler(scl_id) {
      this.$router.push({
        path:'/schoolDetail',
        query: {
            scl_id: scl_id
        }
      })
    },
  }
}
</script>
 
<style lang="scss" scoped>
  @import "@/assets/css/variables.scss";
  @font-face {
    font-family: 'DINCond-Black';
    src: url('../../assets/fonts/DINCond-Black.otf');
  }
  .zy-img {
    @include gwidth;
    margin-top: 10px;
  }
  .zy-school {
    @include gwidth;
    margin-top: 24px;
    .el-col-16 {
      position: relative;
      padding-left: 16px;
      text-align: center;
      .rank-content {
        background: #ffffff;
        border-radius: 10px;
        box-shadow: 0px 1px 2px 0px rgba(44,46,51,0.10); 
        padding: 16px 24px;
        h4 {
          font-size: 20px;
          font-weight: 600;
          color: #2c2e33;
          text-align: left;
          margin: 0;
          padding-bottom: 13px;
          border-bottom: 1px solid #f0f2f5;
        }
      }
    }
  }
  .zyb-box {
    background: none;
    border-radius: 0;
    box-shadow: none;
    position: relative;
    top: 0px;
    .zyb-img {
      width: 24px;
      height: 24px;
      position: relative;
      top: 4px;
    }
    .el-col {
      color: #2c2e33;
      font-size: 24px;
      font-weight: 600;
      border-bottom: 1px solid #f0f2f5;
      padding-bottom: 12px;
    }
    .rank-menu {
      height: 54px;
      border-radius: 6px;
      font-size: 16px;
      font-weight: 400;
      line-height: 54px;
      padding: 0 16px;
      cursor: pointer;
    }
    .rank-menu-active {
      background: #3272ff;
      color: #ffffff;
    }
    .rank-menu-box {
      margin-top: 12px;
    }
  }
  .collapse-box {
        width: 100%;
    min-height: 330px;
        font-size: 0;
        img, .el-image {
            width: 64px;
            height: 64px;
        }
        .el-col-3 {
            width: 11%;
        }
      .el-col-4 {
          float: right;
      }
      .zytb-school-name {
          font-size: 18px;
          font-weight: 600;
          color: #2c2e33;
          margin-bottom: 5px;
      }
      .zytb-school-tag span {
          display: inline-block;
          padding: 3px 8px;
          font-size: 12px;
          color: #909399;
          height: 22px;
          background: #f0f2f5;
          border-radius: 4px;
          line-height: 22px;
          margin-right: 4px;
      }
      .zytb-school-major {
          color: #3272ff;
          font-size: 14px;
          margin-top: 20px;
          position: relative;
          right: -6px;
      }
      .zytb-school-name img {
          width: 16px;
          height: 16px;
          position: relative;
          top: 2px;
          left: 5px;
          margin-left: 5px;
      }
      .zytb-school-name span {
          color: #909399;
          font-size: 12px;
          font-weight: 400;
          position: relative;
          top: -2px;
          left: 5px;
      }
      .zytb-school-tag {
          margin-top: 10px;
      }
      button {
          width: 100px;
          height: 30px;
          border: 1px solid #3272ff;
          border-radius: 5px;
          color: #3272ff;
          font-size: 14px;
          text-align: center;
          line-height: 30px;
          padding: 0;
          margin-top: 15px;
          background-color: #fff;
      }
      .el-col-4 {
          text-align: right;
      }
      button:hover {
          background-color: #fff;
      }
      .con-line {
          width: calc(100% - 40px);
          height: 1px;
          background: #f0f2f5;
          position: absolute;
          right: 0;
          bottom: 0;
      }
      .rank-number {
        width: 28px;
        height: 28px;
        font-size: 20px;
        font-family: 'DINCond-Black';
        text-align: center;
        color: #5e6166;
      }
      .el-col-2 {
        width: 5.5%;
      }
      .rank-top {
        width: 28px;
        height: 28px;
      }
      .el-col-4 {
        font-size: 14px;
        color: #5e6166;
        text-align: right;
        width: 20.5%;
        span {
          font-size: 14px;
          color: #fe9f0a;
          font-weight: 600;
        }
      }
    }
    .collapse-list {
      padding: 20px 0;
      position: relative;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      text-align: left;
      cursor: pointer;
    }
    .rank-infor {
      width: 100%;
      height: 176px;
      background: url('../../assets/images/rank.jpg') no-repeat;
      background-size: 100% 100%;
      padding: 32px;
      box-sizing: border-box;
      h3 {
        color: #ffffff;
        font-weight: 600;
        font-size: 22px;
        margin: 0 auto;
      }
      p {
        width: 70%;
        font-size: 14px;
        font-weight: 400;
        color: rgba(255,255,255,0.70);
        line-height: 24px;
      }
    }
</style>